/* eslint-disable id-match */
exports.BREAKPOINTS = {
  MOBILE_S: {
    label: 'Mobile Small',
    minWidth: 0,
  },
  MOBILE: {
    label: 'Mobile',
    minWidth: 400,
  },
  MOBILE_L: {
    label: 'Mobile Large',
    minWidth: 550,
  },
  TABLET: {
    label: 'Tablet',
    minWidth: 768,
  },
  DESKTOP: {
    label: 'Desktop',
    minWidth: 992,
  },
  DESKTOP_L: {
    label: 'Desktop Large',
    minWidth: 1200,
  },
};
exports.RETINA_DENSITY = '2dppx';
